// Define action creators that dispatch actions:
import config from '../assets/config';
import internalApi from '../assets/internalApi';
import { getLocalErrorCode } from '../assets/lib';
import { setLastErrorCode, clearLastErrorCode } from './pageActions';

import { CACHEDPAGES_IN_PROGRESS, CACHEDPAGES_SET_STATUS } from './types';

export const requestCaching =
  (stateBucket = 'all', urls = [], onSuccess) =>
  async (dispatch) => {
    try {
      dispatch({ type: CACHEDPAGES_IN_PROGRESS, payload: { stateBucket, value: true } });
      const requestUri = `${config.apiUrl.dataServer}/api/v2/cache-page`;
      const payload = { ids: urls.map((u) => u.id) };
      await internalApi('post', requestUri, payload);
      dispatch({ type: CACHEDPAGES_SET_STATUS, payload: { stateBucket, urls, cache_state: 'Recaching...' } });
      dispatch(clearLastErrorCode());
      if (onSuccess) onSuccess();
    } catch (error) {
      console.log(error);
      dispatch({ type: CACHEDPAGES_IN_PROGRESS, payload: { stateBucket, value: false } });
      dispatch(setLastErrorCode(getLocalErrorCode(error)));
    }
  };
